import React from 'react';

import { Button, Typography } from 'lighthouse';

import { RELATED_PRODUCTS_SECTION_ID } from '@/constants/product';

import { TrustBadges } from '../TrustBadges';

import { BoxRemove, ShoppingBag } from 'iconsax-react';

export const UnavailableBuyBox = ({ isOutOfCoverage = false }: { isOutOfCoverage?: boolean }) => {
    const scrollToRelatedProducts = () => {
        document.getElementById(RELATED_PRODUCTS_SECTION_ID)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <aside
            className='nice-scroll sticky top-20 max-h-[calc(100vh-6rem)] w-full self-start overflow-y-auto rounded-lg bg-white
                shadow-[0_1px_3px_rgba(15,60,100,0.05),0_10px_30px_rgba(15,60,100,0.07)]'>
            <div className='flex flex-col gap-4 p-4'>
                <div className='flex flex-col items-center gap-2 rounded-lg border border-solid border-red-100 bg-red-50/60 px-4 py-6 text-center'>
                    <Typography
                        variant='subtitle1'
                        fontWeight={700}
                        className='inline-flex items-center justify-center gap-2 !text-red-700'
                        component='h2'>
                        <BoxRemove color='currentcolor' className='size-5 shrink-0' variant='Bold' />
                        {isOutOfCoverage ? 'خارج از محدوده پوشش فروشنده' : 'این کالا ناموجود است'}
                    </Typography>
                    <Typography variant='caption' color='blackMediumEmphasis' component='p' className='leading-5'>
                        در حال حاضر امکان خرید این محصول وجود ندارد.
                    </Typography>
                </div>

                <Button
                    variant='contained'
                    color='primary'
                    size='large'
                    startIcon={<ShoppingBag size={18} color='currentcolor' />}
                    onClick={scrollToRelatedProducts}
                    className='!min-h-11'>
                    محصولات مرتبط
                </Button>

                <TrustBadges />
            </div>
        </aside>
    );
};
